import cn from 'classnames';
import React from 'react';

import s from 'components/complex/payments/Product/Product.module.scss';

import type { ProductType } from 'redux-store/slices/products/types';

interface Props {
  product: ProductType;
}

export default function DiscountLabel({ product }: Props): JSX.Element {
  const { discount } = product.prices[0];

  return <div className={cn(s.discountLabel)}>-{Number(discount)}%</div>;
}
